import styles from "./CheckoutSummary.module.css";
import WhatsIncluded, {
  WhatsIncludedProps,
} from "./CheckoutTotal/WhatsIncluded";
import { CheckoutSummary, CheckoutSummaryProps } from ".";

type AlternateCheckoutSummaryProps = CheckoutSummaryProps & WhatsIncludedProps;

export default function AlternateCheckoutSummary({
  inclusionModalOpen,
  setInclusionModalOpen,
  ...props
}: AlternateCheckoutSummaryProps) {
  return (
    <div className={styles.AlternateSummaryContainer}>
      <CheckoutSummary {...props}>
        <WhatsIncluded
          inclusionModalOpen={inclusionModalOpen}
          setInclusionModalOpen={setInclusionModalOpen}
        />
      </CheckoutSummary>
    </div>
  );
}
